export const volumes = [
  {
    number: 1,
    title: 'Forza Base e Stabilità',
    tagline: 'Costruisci una base più solida',
    sessions: '61 sessioni',
    months: 'Mesi 1–2',
    desc: 'Crea fondamenta solide e forza strutturale nei tuoi allievi fin dal primo giorno.',
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 2,
    title: 'Potenza e Trasferimento',
    tagline: 'Trasforma la forza in potenza',
    sessions: '61 sessioni',
    months: 'Mesi 3–4',
    desc: 'Sviluppa velocità, esplosività e trasferimento diretto ai movimenti atletici reali.',
    bar: 'bg-green-500',
    text: 'text-green-400',
    border: 'border-t-green-500',
  },
  {
    number: 3,
    title: 'Resistenza Metabolica e Fat Loss',
    tagline: 'Più resistenza. Più calorie bruciate.',
    sessions: '61 sessioni',
    months: 'Mesi 5–6',
    desc: 'Brucia grasso e porta al limite il condizionamento metabolico del tuo gruppo.',
    bar: 'bg-yellow-400',
    text: 'text-yellow-300',
    border: 'border-t-yellow-400',
  },
  {
    number: 4,
    title: 'Ipertrofia Funzionale',
    tagline: 'Più muscoli. Più funzionalità.',
    sessions: '61 sessioni',
    months: 'Mesi 7–8',
    desc: "Costruisci massa muscolare in modo funzionale con protocolli di ipertrofia adattati all'allenamento di gruppo.",
    bar: 'bg-purple-500',
    text: 'text-purple-400',
    border: 'border-t-purple-500',
  },
  {
    number: 5,
    title: 'Agilità e Prestazione Atletica',
    tagline: 'Muoviti più veloce. Vai più lontano.',
    sessions: '61 sessioni',
    months: 'Mesi 9–10',
    desc: 'Migliora coordinazione, agilità e capacità atletica generale a qualsiasi livello.',
    bar: 'bg-cyan-500',
    text: 'text-cyan-400',
    border: 'border-t-cyan-500',
  },
  {
    number: 6,
    title: 'Specializzazione e Sfide Finali',
    tagline: 'Integra. Performa. Completa.',
    sessions: '60 sessioni',
    months: 'Mesi 11–12',
    desc: "Metti alla prova tutto l'anno con sfide e test competitivi.",
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
]

export const sessionFeatures = [
  { title: 'Obiettivo del giorno', desc: 'Così sai sempre esattamente dove stai andando' },
  { title: 'Riscaldamento pronto', desc: 'Basta riscaldamenti improvvisati' },
  { title: '3 versioni: A/B/C', desc: 'Gruppo misto o gruppi separati: funziona in entrambi i casi' },
  { title: 'Serie, ripetizioni e tempi', desc: 'Tutto specificato, niente di vago' },
  { title: 'Defaticamento professionale', desc: 'Chiudi ogni lezione con struttura' },
  { title: 'Consiglio del Coach', desc: 'Sei alle prime armi? Impari. Sei già esperto? Confermi.' },
  { title: 'Una sessione per pagina', desc: 'Apri, insegna, fatto' },
]

export const featureChips = [
  'Palestra + Boxe + Funzionale',
  'Programma annuale completo',
  'Versioni A/B/C per livello',
  'Riscaldamenti e defaticamenti',
  '365 sessioni pronte',
  'Solo attrezzatura di base',
]
